import React from "react";
import { useTranslation } from "react-i18next";
import RuleBodyPage from "components/common/RuleBodyPage";
import { RuleModalBodyProps } from "components/common/RuleModal";

function LuckyDrawRuleBody({ page }: RuleModalBodyProps) {
  const { t } = useTranslation();
  const rules = t("LuckyDraw.rules", { returnObjects: true }) as string[];

  const phaseContainer =
    "flex items-center gap-3 p-3 bg-gray-800 rounded-lg mb-4";
  const iconContainer =
    "w-8 h-8 min-w-9 min-h-9 flex items-center justify-center rounded-full text-sm";

  return (
    <div className="relative flex">
      {/* Page 1: 게임 소개 및 모드 설명 */}
      <RuleBodyPage show={page === 0}>
        <div className="space-y-4">
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-blue-600`}>
              <i className="fas fa-hashtag" />
            </div>
            <div>
              <div className="font-medium text-blue-300 mb-1">{rules[2]}</div>
              <div className="text-sm text-gray-300">{rules[3]}</div>
            </div>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-purple-600`}>
              <i className="fas fa-gift" />
            </div>
            <div>
              <div className="font-medium text-purple-300 mb-1">{rules[4]}</div>
              <div className="text-sm text-gray-300">{rules[5]}</div>
            </div>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-orange-600`}>
              <i className="fas fa-history" />
            </div>
            <div>
              <div className="font-medium text-orange-300 mb-1">{rules[8]}</div>
              <div className="text-sm text-gray-300">{rules[9]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 1: 활용 예시 */}
      <RuleBodyPage show={page === 1}>
        <div className="space-y-4">
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-blue-300 mb-2">{rules[10]}</div>
            <ul className="list-disc list-inside space-y-1 text-sm text-blue-200">
              <li>{rules[11]}</li>
              <li>{rules[12]}</li>
              <li>{rules[13]}</li>
              <li>{rules[14]}</li>
            </ul>
          </div>

          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-purple-300 mb-2">{rules[15]}</div>
            <ul className="list-disc list-inside space-y-1 text-sm text-purple-200">
              <li>{rules[16]}</li>
              <li>{rules[17]}</li>
              <li>{rules[18]}</li>
              <li>{rules[19]}</li>
            </ul>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-indigo-600`}>
              <i className="fas fa-lightbulb" />
            </div>
            <div>
              <div className="font-medium text-indigo-300 mb-1">
                {rules[20]}
              </div>
              <div className="text-sm text-gray-300">{rules[21]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>
    </div>
  );
}

export default LuckyDrawRuleBody;
